import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../constants'
import { mediaQuery } from '../utils'

export const ButtonLabel = styled.span`
    margin-left: 10px;
`

export const Table = styled.div`
    color: ${colors.greydark};
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    font-size: 14px;
    height: 100%;
`

export const TableBody = styled.div`
    width: 100%;
    overflow-y: auto;

    ${({ noMarginTop, complexTable }) => {
        if (!noMarginTop && complexTable)
            return `
        margin-top: 55px;
      `
        if (!noMarginTop)
            return `
        ${mediaQuery.mobile(`
        margin-top: 92px;
      `)}
    `
    }}

    ${({ withTitle, complexTable }) => {
        if (withTitle && complexTable) return 'height: calc(100% - 168px);'
        if (withTitle) return 'height: calc(100% - 85px);'
        return 'height: calc(100% - 38px);'
    }}

    &::-webkit-scrollbar {
        width: 5px;
    }
`

export const TableHeader = styled.div`
    width: 100%;
    position: relative;
    top: 0;

    ${mediaQuery.mobile(`
    text-align: center;
  `)}
`

export const Title = styled.div`
    padding: 10px 15px 0;
    color: #3b4146;
    font-size: 15px;
    background: #f1f1f1;
    font-weight: bold;
    letter-spacing: 1px;
`

export const Header = styled.div`
    background: ${colors.greylightest};
    color: ${colors.grey};
    display: flex;
    font-size: 12px;
    font-weight: 600;
    padding: 10px 15px 10px;
    text-transform: uppercase;
    width: 100%;
`

const FAIcon = styled(FontAwesomeIcon)`
    margin-left: 3px;
`

export const SortedAsc = () => <FAIcon icon="chevron-down" />

export const SortedDesc = () => <FAIcon icon="chevron-up" />

export const Row = styled.div`
    align-items: center;
    display: flex;
    padding: 10px 15px;
    width: 100%;

    ${({ noOverflow }) => !noOverflow && `overflow: hidden;`}
    ${({ expired }) => expired && `background-color: ${colors.redlightest};`}
  ${({ selected, striped, found }) => {
        let css = ''
        if (selected) css += `background-color: ${colors.blue}; color: ${colors.white};`
        else if (found) css += `background-color: ${colors.yellowlight};`
        else if (striped) css += `background-color: ${colors.bluelightest};`
        if (!selected)
            css += `&:active,
    &:focus,
    &:hover {
      background: ${colors.blue};
      color: #ffffff;

      button {
        color: #ffffff;
      }
    };`
        return css
    }}

  ${({ clickable }) =>
        clickable &&
        `
      cursor: pointer;
    `}
`

export const Cell = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${({ align }) => align && `text-align: ${align};`}
    ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft};`}
  ${({ width }) => (width ? `width: ${width};` : `flex: 1;`)}
  ${({ withPointer }) => withPointer && `cursor: pointer; user-select: none;`}
  ${({ expander }) => expander && `display: inline-block; vertical-align: middle;`}

  &:last-child {
        overflow: visible;
    }
`

export const ColSelectorCell = styled(Cell)`
    color: ${colors.blue};
    font-size: 11px;
    margin-left: auto;

    &:hover {
        color: ${colors.bluedark};
        text-decoration: underline;
    }
`
